import { getMentionUsers, addStickyNote, updateStickyNote } from '../../../../services/popupApi';

export const api = {
  getMentionOptions: async (_field, search) => getMentionUsers(search),
  submit: async (values, context) => {
    const targetDate = values.targetDate ? values.targetDate.toISOString() : '';

    if (context.editingNoteId) {
      await updateStickyNote(context.editingNoteId, {
        title: values.heading,
        targetDate,
        notes: values.comments,
      });
    } else {
      await addStickyNote({
        relatedIds: context.selectedIds,
        module: context.moduleName,
        title: values.heading,
        targetDate,
        notes: values.comments,
      });
    }
    window.dispatchEvent(new Event('sticky-notes:refresh'));
  },
};
